import "./wire-management-state-controller.scss";

/**
 * Server-side pagination controls.
 * `loaded` rows are already fetched, `total` is the backend count.
 * "Show more" asks for the next page, "Show all" for the rest.
 */
const WireManagementStateController = ({
  loaded,
  total,
  pageSize = 10,
  loading,
  onShowMore,
  onShowAll,
}) => {
  const totalItems = total || 0;
  const endItem = Math.min(loaded, totalItems);
  const remaining = totalItems - loaded;
  const nextChunk = Math.min(pageSize, remaining);
  const hasMore = remaining > 0;

  return (
    <div className="pagination-wrapper">
      <span>
        {totalItems === 0 ? 0 : 1}-{endItem} of {totalItems}
      </span>
      {hasMore && (
        <>
          <hr className="vertical-hr" />
          <span
            className={loading ? "pagination-disabled" : ""}
            onClick={() => !loading && onShowMore()}
          >
            Show {nextChunk} more
          </span>
          <hr className="vertical-hr" />
          <span
            className={loading ? "pagination-disabled" : ""}
            onClick={() => !loading && onShowAll()}
          >
            Show all
          </span>
        </>
      )}
    </div>
  );
};

export default WireManagementStateController;
